import { useState, useCallback, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { useParams, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import axiosCacheAdapter from "axios-cache-adapter";
import { toast } from "sonner";

var baseUrl = 'https://dash.bestdiplomats.org';
const cache = axiosCacheAdapter.setupCache({
    maxAge: 5 * 60 * 1000,
});

const api = axios.create({
    adapter: cache.adapter,
});

var userEmail;
var JSToken;
var accessToken;
if (localStorage.user) {
    userEmail = localStorage.user_email;
    JSToken = JSON.parse(localStorage.user);
    accessToken = JSToken.access_token;
}

const config = {
    headers: { Authorization: `Bearer ${accessToken}` },
};

export default function ScholarshipTaskDetail() {
    const location = useLocation()
    const navigate = useNavigate()

    const [files, setFiles] = useState([]);
    const { taskID } = useParams();
    const { taskData } = location.state || {};
    const { status } = location.state || {};
    const [taskDetails, setTaskDetails] = useState({
        title: "",
        description: "",
        valid_from: "",
        valid_till: "",
        attachments: []
    })
    const [submitImage, setSubmitImage] = useState()
    const [disableSaveButton, setDisableSaveButton] = useState()

    function uploadDocument(e) {
        const file = e[0];
        const formData = new FormData();
        formData.append("file", file);
        formData.append("is_private", 0);

        const uploadApi = async () => {
            try {
                setSubmitImage(true)
                await axios
                    .post(
                        "https://dash.bestdiplomats.org/api/method/upload_file",
                        formData,
                        config
                    )
                    .then(async (res) => {
                        setTaskDetails((prev) => ({
                            ...(prev || { title: "", description: "", valid_from: "", valid_till: "", attachments: [] }),
                            attachments: [
                                ...((prev && prev.attachments) || []),
                                { attachment: res.data.message.file_url }
                            ]
                        }));

                        setSubmitImage(false)

                    });
            } catch (e) {
                console.log(e);
                setSubmitImage(false)
                toast.error("Error uploading the file. Please try again.");

            }
        };

        uploadApi();
    }

    const onDrop = useCallback((acceptedFiles) => {
        setFiles([...files, ...acceptedFiles]);
    }, [files]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: uploadDocument,
    })

    const handleSubmit = async (e) => {
        e.preventDefault();
        setDisableSaveButton(true);

        let data;
        if (taskDetails?.attachments?.length) {
            data = {
                ...taskDetails,
                attachments: taskDetails.attachments.map(file => ({
                    attachment: file.attachment
                }))
            };
        } else {
            data = { ...taskDetails };
        }

        try {
            let response;

            if (status === 'edit') {
                response = await api.put(
                    `https://dash.bestdiplomats.org/api/resource/Scholarship Tasks/${taskDetails.name}`,
                    data,
                    config
                );
            } else if (status === 'create') {
                response = await api.post(
                    `https://dash.bestdiplomats.org/api/resource/Scholarship Tasks`,
                    data,
                    config
                );
            }

            if (response?.status === 200 || response?.status === 201) {
                toast.success("Changes saved successfully!");
                navigate(-1);
            } else {
                toast.error("Unexpected error occurred.");
            }
        } catch (err) {
            console.error(err);
            toast.error("Error saving changes. Please try again.");
        } finally {
            setDisableSaveButton(false);
        }
    };


    useEffect(() => {
        setTaskDetails(taskData)
    }, [taskData, status, taskID])

    const handleDeleteFile = (filename) => {
        const attachment = taskDetails.attachments.filter((file) => file.attachment !== filename)
        setTaskDetails((prev) => ({
            ...prev,
            attachments: attachment
        }))
    }

    return (
        <div className="max-w-3xl mx-auto p-4">
            <div className="flex items-center gap-4">
                <button
                    onClick={() => navigate(-1)}
                    className="text-gray-800 px-3 py-1.5 rounded-lg"
                >
                    ← Back
                </button>
            </div>
            <div className="shadow-lg rounded-2xl bg-white p-6 space-y-6">
                {
                    status === 'create' ?
                        <h2 className="text-2xl font-semibold text-gray-800">Create Task</h2> :
                        <h2 className="text-2xl font-semibold text-gray-800">Task</h2>
                }

                {/* File Upload */}
                {
                    submitImage ? (
                        <div className="flex items-center justify-center space-x-3 text-indigo-600 bg-gray-50 border-2 border-dashed rounded-xl p-6">
                            <svg
                                aria-hidden="true"
                                role="status"
                                className="inline w-6 h-6 animate-spin text-indigo-600"
                                viewBox="0 0 100 101"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 
             22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 
             50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 
             50 91.5094C72.5987 91.5094 90.9186 73.1895 
             90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 
             50 9.67226C27.4013 9.67226 9.08144 27.9921 
             9.08144 50.5908Z"
                                    fill="#E5E7EB"
                                />
                                <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 
             35.9116 97.0079 33.5539C95.2932 28.8227 
             92.871 24.3692 89.8167 20.348C85.8452 
             15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 
             4.10194 63.2754 1.94025 56.7698 
             1.05124C51.7666 0.367541 46.6976 0.446843 
             41.7345 1.27873C39.2613 1.69328 37.813 
             4.19778 38.4501 6.62326C39.0873 9.04874 
             41.5694 10.4717 44.0505 10.1071C47.8511 
             9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 
             10.7766 65.9928 12.5457 70.6331 
             15.2552C75.2735 17.9648 79.3347 21.5619 
             82.5849 25.841C84.9175 28.9121 86.7997 
             32.2913 88.1811 35.8758C89.083 38.2158 
             91.5421 39.6781 93.9676 39.0409Z"
                                    fill="currentColor"
                                />
                            </svg>
                            <span className="text-sm font-medium">Uploading...</span>
                        </div>
                    ) : status !== "preview" ? (
                        <div
                            {...getRootProps()}
                            className={`border-2 border-dashed rounded-xl p-6 text-center cursor-pointer transition 
        ${isDragActive ? "border-indigo-500 bg-indigo-50" : "border-gray-300 bg-gray-50"}`}
                        >
                            <input {...getInputProps()} />
                            {isDragActive ? (
                                <p className="text-indigo-600">Drop the files here ...</p>
                            ) : (
                                <p className="text-gray-500">
                                    Drag & drop files here, or{" "}
                                    <span className="text-indigo-600 font-medium">browse</span>
                                </p>
                            )}
                            {files.length > 0 && (
                                <ul className="mt-3 text-sm text-gray-600">
                                    {files.map((file, idx) => (
                                        <li key={idx}>📎 {file.name}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ) : (
                        ""
                    )
                }

                {/* Display files */}
                {
                    <div>
                        {taskDetails?.attachments?.length > 0 ? (
                            <div>
                                <h4 className="block text-sm font-medium text-gray-700 mb-1">Task Attachments</h4>
                                <ul className="space-y-3">
                                    {taskDetails.attachments.map((file, i) => (
                                        <li
                                            key={i}
                                            className="border rounded-lg p-4 flex items-center justify-between hover:bg-gray-50 transition"
                                        >
                                            <div className="flex items-center gap-2">
                                                <svg
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    className="text-gray-500"
                                                >
                                                    <path
                                                        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                    />
                                                    <polyline
                                                        points="14,2 14,8 20,8"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                    />
                                                </svg>
                                                <a
                                                    href={baseUrl + file?.attachment}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="text-blue-600 underline"
                                                >
                                                    {file?.attachment?.split("/").pop() ?? file?.attachment}
                                                </a>
                                            </div>

                                            {
                                                status !== 'preview' ?
                                                    < button
                                                        onClick={() => handleDeleteFile(file.attachment)}
                                                        className="ml-4 text-red-600 hover:text-red-800 font-medium"
                                                    >
                                                        Delete
                                                    </button>
                                                    :
                                                    ''
                                            }
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ) : null}
                    </div>

                }

                {/* Form */}
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Title</label>
                        <input
                            type="text"
                            value={taskDetails?.title}
                            disabled={status === 'preview'}
                            onChange={(e) => setTaskDetails((prev) => ({
                                ...prev,
                                title: e.target.value,
                            }))}
                            className="mt-1 block w-full rounded-xl border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                            placeholder="Enter task title"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700">Description</label>
                        <textarea
                            rows={4}
                            value={taskDetails?.description}
                            disabled={status === 'preview'}
                            onChange={(e) => setTaskDetails((prev) => ({
                                ...prev,
                                description: e.target.value,
                            }))}
                            className="mt-1 block w-full rounded-xl border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                            placeholder="Write task details..."
                            required
                        />
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Start Date</label>
                            <input
                                type="date"
                                value={taskDetails?.valid_from}
                                disabled={status === 'preview'}
                                onChange={(e) => setTaskDetails((prev) => ({
                                    ...prev,
                                    valid_from: e.target.value,
                                }))}
                                className="mt-1 block w-full rounded-xl border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">End Date</label>
                            <input
                                type="date"
                                value={taskDetails?.valid_till}
                                disabled={status === 'preview'}
                                onChange={(e) => setTaskDetails((prev) => ({
                                    ...prev,
                                    valid_till: e.target.value,
                                }))} className="mt-1 block w-full rounded-xl border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                required
                            />
                        </div>
                    </div>

                    {
                        status !== 'preview' ?
                            <div className="flex justify-end">
                                <button
                                    type="submit"
                                    disabled={disableSaveButton}
                                   className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm shadow hover:bg-blue-700 transition 
                                    disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    {
                                        status === 'create' ? 'Create Task' : 'Edit Task'
                                    }
                                </button>
                            </div>
                            :
                            ''
                    }

                </form>
            </div>
        </div >
    );
}
